import type { EventFilter } from "@/Modules/Chat/WebSocketManager";

import {
  ChatRoomItemTypeMessageWebSocket,
  MessageTypeWebSocket,
  type EventMessageConfirmationWebSocket,
} from "@/Modules/Chat/Models/WebSocket";

import { hasValue, isObject } from "@/Utils/Objects";
import { isValidString } from "@/Utils/String";

import { useChatStore, type ChatStore } from "../Store";

export interface ExtraParamsConfirmChatRoomItem {
  chatStore: ChatStore;
}

export const isConfirmChatRoomItem = (message: unknown): message is EventMessageConfirmationWebSocket => {
  return (
    isObject(message) &&
    hasValue(message.type) &&
    isValidString(message.eid) &&
    isValidString(message.chat) &&
    isValidString(message.rd_eid) &&
    message.type === MessageTypeWebSocket.CHAT_ROOM_ITEM &&
    message.etype === ChatRoomItemTypeMessageWebSocket.CONFIRMATION
  );
};

export const confirmSendMessageHandler = (
  message: EventMessageConfirmationWebSocket,
  { chatStore = useChatStore() }: ExtraParamsConfirmChatRoomItem
): Promise<{ chatId: string; rdIds: string[] } | undefined> => {
  const chatId = message.chat;

  if (!hasValue(chatStore.rooms[chatId]) || chatStore.rooms[chatId].events.length === 0) {
    return Promise.resolve(undefined);
  }

  if (hasValue(message.rd_eids) && message.rd_eids.length > 0) {
    chatStore.rooms[chatId].events = chatStore.rooms[chatId].events.map((event) => {
      if (message.rd_eids.includes(event.id)) {
        // @ts-expect-error isReceived is not in the type
        event.isReceived = true;
      }

      return event;
    });
  }

  return Promise.resolve({ chatId, rdIds: message.rd_eids });
};

export default {
  isType: isConfirmChatRoomItem,
  handler: confirmSendMessageHandler,
} as EventFilter<ExtraParamsConfirmChatRoomItem>;
